import { render } from "./ValidationProvider.vue?vue&type=template&id=450b415e&ts=true"
import script from "./ValidationProvider.vue?vue&type=script&lang=ts"
export * from "./ValidationProvider.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__